// extracted by mini-css-extract-plugin
module.exports = {"number":"Number-module--number--PHhBl","extraNumber":"Number-module--extraNumber--2HKMU"};